import { getCurrentProjectIdentifier } from '@neptune/current-project-business-logic';
import { FETCH_STATUS_NONE } from '@neptune/shared/common-domain';

import { AppState } from 'state/types';

import getParentState from '../selectors';

import { LeaderboardCountState } from './reducer';

const INITIAL_STATE: LeaderboardCountState = {
  fetchStatus: FETCH_STATUS_NONE,
  totalCount: undefined,
};

export function getLeaderboardCountState(state: AppState): LeaderboardCountState {
  return getParentState(state).lbCount[getCurrentProjectIdentifier(state)] ?? INITIAL_STATE;
}
